import type { LevelConfig } from '../index';

export const level5: LevelConfig = {
  id: 'level_5',
  stage: '1',
  mapId: 'map_05',
  timeLimitSec: 150,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 30 },
  enemies: [
    // Tutorial room enemy
    {
      type: 'BASIC_SCAMMER',
      position: { x: 400, y: 256 },
      patrolPath: [
        { x: 400, y: 256 },
        { x: 400, y: 384 },
        { x: 256, y: 384 },
        { x: 256, y: 256 },
      ],
    },
    // Main area enemies
    {
      type: 'BASIC_SCAMMER',
      position: { x: 700, y: 600 },
      patrolPath: [
        { x: 700, y: 600 },
        { x: 700, y: 800 },
        { x: 500, y: 800 },
        { x: 500, y: 600 },
      ],
    },
    {
      type: 'BASIC_SCAMMER',
      position: { x: 1100, y: 500 },
      patrolPath: [
        { x: 1100, y: 500 },
        { x: 1100, y: 700 },
        { x: 1300, y: 700 },
        { x: 1300, y: 500 },
      ],
    },
    {
      type: 'BASIC_SCAMMER',
      position: { x: 600, y: 1200 },
      patrolPath: [
        { x: 600, y: 1200 },
        { x: 600, y: 1400 },
        { x: 400, y: 1400 },
        { x: 400, y: 1200 },
      ],
    },
    {
      type: 'SUPPORT_SCAMMER',
      position: { x: 1000, y: 1500 },
      patrolPath: [
        { x: 1000, y: 1500 },
        { x: 1000, y: 1700 },
        { x: 1200, y: 1700 },
        { x: 1200, y: 1500 },
      ],
    },
  ],
  loot: [
    // 30 coins spread across the map
    ...Array.from({ length: 30 }, (_, i) => ({
      type: 'COIN' as const,
      position: {
        x: 256 + (i % 6) * 200,
        y: 512 + Math.floor(i / 6) * 200,
      },
      value: 10,
    })),
  ],
  startingWeapon: 'RIFLE',
  startingAmmo: 3,
  unlocks: [
    { type: 'shop', id: 'ammo_upgrade_4' },
    { type: 'shop', id: 'ammo_upgrade_5' },
  ],
  tutorialSteps: [
    {
      text: 'Ты получил ружьё! Нажми ATK чтобы выстрелить',
      position: { x: 256, y: 192 },
      trigger: 'enter',
    },
  ],
};
